import { fetchData } from '@umu/umu-fetch';
import API from '../../path';
import { KEYWORD_TYPE } from '@umu/umu-types';

export interface IKeywordItem {
    id: number;
    keyword: string;
    synonyms: string[];
}
export const getHomeworkAIKeywords = (data: {
    parent_id: string;
    type?: KEYWORD_TYPE;
}): Promise<IResponse<IKeywordItem[]>> => {
    return fetchData(API.GET_HOMEWORK_KEYWORDS, {
        ...data,
        type: data.type || KEYWORD_TYPE.KEYWORD,
        parent_type: 4,
    });
};

export const getHomeworkAIAllKeywords = (elementId: string) => {
    return Promise.all([
        getHomeworkAIKeywords({
            parent_id: elementId,
            type: KEYWORD_TYPE.KEYWORD,
        }),
        getHomeworkAIKeywords({
            parent_id: elementId,
            type: KEYWORD_TYPE.SHIELD,
        }),
    ])
        .then((res) => {
            const keywords = res[0].data || [];
            const shieldKeywords = res[1].data || [];
            return {
                keywords,
                shieldKeywords,
            };
        })
        .catch(() => {
            return {
                keywords: [],
                shieldKeywords: [],
            };
        });
};
